import { LevelSection } from 'app/levels/levels';
import { createContext, useContext } from 'react';

type LevelContext = {
	allLevels: LevelSection[];
	currentLevel: string | null;
	setCurrentLevel: (level: string | null) => void;
	completeLevel: (level: string) => void;
	getNextLevel: () => string | null;
	canPlayLevel: (level: string) => boolean;
	unlockAllLevels: () => void;
	resetUnlockedLevels: () => void;
};

const context = createContext<LevelContext | null>(null);

export function useLevelContext(): LevelContext {
	const contextValue = useContext(context);

	if (contextValue === null) {
		throw new Error('useLevelContext must be used within a LevelContextProvider');
	}

	return contextValue;
}

export const LevelContextConsumer = context.Consumer;
export const LevelContextProvider = context.Provider;
